import axios from 'axios'
import { JWT_TOKEN } from '@/common/constants'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { backendDomain } from '@/shareds/utils'
import { stringify } from 'qs'

export const serializarQueryString = (params: any) => stringify(params, {arrayFormat: 'repeat'})

const relativePath = backendDomain()

const request = axios.create({
	baseURL: `${relativePath}`,
	paramsSerializer: params => stringify(params, {arrayFormat: 'repeat'}),
})

request.interceptors.request.use(
	config => {
		const token: string = localStorage.getItem(JWT_TOKEN) || ''
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}
		return config
	},
	error => Promise.reject(error),
)

let encerrandoSessao = false

const isFalhaDeAutenticacao = (error: any) => {
	const status = error.response?.status
	if (status !== 401 && status !== 403) return false
	if (!localStorage.getItem(JWT_TOKEN)) return false
	if (status === 401) return true

	const corpoDoErro = error.response?.data
	const acessoNegadoDeRota = Array.isArray(corpoDoErro) || corpoDoErro instanceof Blob
	return !acessoNegadoDeRota
}

request.interceptors.response.use(
	response => response.data,
	error => {
		if (!encerrandoSessao && isFalhaDeAutenticacao(error)) {
			encerrandoSessao = true
			UserLoginStore.encerrarSessaoPorFalhaDeAutenticacao()
		}
		return Promise.reject(error)
	},
)

export default request
